import _ from 'lodash';
import guid from 'uuid';

import { createSectionStyles } from 'factories/style';
import * as Models from 'models';

export const createSection = ({
  id = guid(),
  name = '',
  screenDefinition = '',
  styles,
  carouselIds = [],
} = {} as Partial<Models.Section>): Models.Section => ({
  id,
  name,
  screenDefinition,
  styles: createSectionStyles(styles),
  carouselIds,
});

export const createSectionsFromScreenDefinition = (
  sections: Partial<Models.MasterScreen.Section>[],
  screenDefinitionId: string,
): Models.Sections => _.reduce(
  sections,
  (accSections, section) => {
    const sectionEntity = createSection({
      name: section.name,
      screenDefinition: screenDefinitionId,
    });
    accSections[sectionEntity.id] = sectionEntity;

    return accSections;
  },
  {} as Models.Sections,
);

export const createSections = (sections: Models.Sections): Models.Sections => _.reduce(
  sections,
  (accSections, section) => {
    const createdSection = createSection(section);
    accSections[createdSection.id] = createdSection;

    return accSections;
  },
  {} as Models.Sections,
);
